import React, { useEffect } from 'react';
import { AlertTriangle, Check } from 'lucide-react';

const Toast = ({ message, type, onClose }) => {
    useEffect(() => { const timer = setTimeout(onClose, 3000); return () => clearTimeout(timer); }, [onClose]);
    const bgClass = type === 'error' ? 'bg-red-500' : 'bg-emerald-600';
    return (
        <div className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 ${bgClass} text-white px-6 py-3 rounded-xl shadow-2xl flex items-center gap-3 z-[200] animate-fade-in-up transition-all`}>
            {type === 'error' ? <AlertTriangle className="w-5 h-5" /> : <Check className="w-5 h-5" />} <span className="font-medium">{message}</span>
        </div>
    );
};

export default Toast;
